import { render, staticRenderFns } from "./SecondStepDocumentIntrare.vue?vue&type=template&id=77881bfb&scoped=true&"
import script from "./SecondStepDocumentIntrare.ts?vue&type=script&lang=ts&"
export * from "./SecondStepDocumentIntrare.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77881bfb",
  null
  
)

export default component.exports